import React, { useState } from 'react';
import { Card, CardBody, TabContent, TabPane } from 'reactstrap';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import FSBModal from 'components/common/FSBModal';
import CustomTabs from 'components/CustomTabs';
import Heading from 'components/Heading';
import EditPlans from 'components/EditPlans';
import { VENDOR_TYPES } from 'pages/Vendor/constants';
import { DELETE_SUBSCRIPTION_PLAN } from 'pages/SubscriptionPlans/subscriptionPlanGraphQL';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import IndianAddons from './components/IndianAddons';
import ForeignAddons from './components/ForeignAddons';

const Addons = () => {
  const [activeTab, setActiveTab] = useState(VENDOR_TYPES.INDIAN);
  const [subscriptionPlanRow, setSubscriptionPlanRow] = useState('');

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [vendorType, setVendorType] = useState({
    type: ADD_EDIT_CONSTANT.ADD,
    value: '',
    refetch: () => {},
  });

  const [deleteRowId, setDeleteRowId] = useState({ id: '', refetch: () => {} });
  const [showDeleteRecord, setDeleteRecord] = useState(false);

  const [deleteSubscriptionPlan] = useMutation(DELETE_SUBSCRIPTION_PLAN, {
    // eslint-disable-next-line no-shadow
    onCompleted: ({ deleteSubscriptionPlan }) => {
      toast.success(deleteSubscriptionPlan?.message);
      deleteRowId?.refetch();
      setDeleteRowId({ id: '', refetch: () => {} });
      setDeleteRecord(!showDeleteRecord);
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ message }) => {
        toast.error(message);
        return message;
      });
    },
  });

  const drawerToggle = (value, type, refetch = () => {}) => {
    setIsDrawerOpen(!isDrawerOpen);
    setVendorType({ type, value, refetch });
    setSubscriptionPlanRow(value);
  };
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const toggleDeleteRecord = (id, refetch = () => {}) => {
    setDeleteRecord(!showDeleteRecord);
    setDeleteRowId({ id, refetch });
  };

  const onDeleteConfirmation = async () => {
    try {
      await deleteSubscriptionPlan({
        variables: { subscriptionPlanId: deleteRowId?.id },
      });
    } catch (e) {
      console.error(e);
    }
  };
  const handleClickEdit = (data, edit, refetch = () => {}) => {
    drawerToggle(data, edit, refetch);
  };

  return (
    <div className="staff-page">
      <div className="mb-3 top-head">
        <Heading title="Add-ons" />
      </div>
      <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />
      <FSBModal
        title={`${subscriptionPlanRow?.planName}`}
        open={isDrawerOpen}
        toggleAlert={drawerToggle}
        onClose={drawerToggle}
        message=""
        modalClass="right-drawer"
      >
        <EditPlans
          drawerToggle={drawerToggle}
          currentRow={subscriptionPlanRow}
          refetch={vendorType.refetch}
        />
      </FSBModal>
      <Card className="border-0 card-box page-card-box ">
        <CardBody>
          <CustomTabs
            tabs={[VENDOR_TYPES.INDIAN, VENDOR_TYPES.FOREIGN]}
            selectedTab={activeTab}
            onTabChange={toggle}
            className="mb-2"
          />
          <TabContent activeTab={activeTab}>
            {activeTab === VENDOR_TYPES.INDIAN && (
              <TabPane tabId={VENDOR_TYPES.INDIAN}>
                <IndianAddons
                  handleClickEdit={handleClickEdit}
                  toggleDeleteRecord={toggleDeleteRecord}
                />
              </TabPane>
            )}
            {activeTab === VENDOR_TYPES.FOREIGN && (
              <TabPane tabId={VENDOR_TYPES.FOREIGN}>
                <ForeignAddons
                  handleClickEdit={handleClickEdit}
                  toggleDeleteRecord={toggleDeleteRecord}
                />
              </TabPane>
            )}
          </TabContent>
        </CardBody>
      </Card>
    </div>
  );
};

export default Addons;
